<ng-container *ngIf="this.usuario.typ_id == 1">

<!-- Modal de solicitud -->
<div class="modal-container" *ngIf="modalActual === 'solicitud'">
  <h2 class="modal-title">Solicitud de asignación de atención inmediata</h2>

  <div class="modal-avatar">
    <span class="avatar-initials">
      {{ data.paciente.use_name.charAt(0) }}{{ data.paciente.use_paternal_surname.charAt(0) }}
    </span>
  </div>

  <h3 class="modal-name">
    {{ data.paciente.use_name }} {{ data.paciente.use_paternal_surname }} {{ data.paciente.use_maternal_surname }}
  </h3>

  <p class="modal-reason"><strong>Motivo de consulta:</strong> {{ data.paciente.tel_doc_od_reason }}</p>

  <div class="buttons-box row">
    <div class="col">
      <button mat-button class="btn-secondary" (click)="mostrarModal('cancelar')">
        <p class="m-0" style="font-weight: 600;">
          Rechazar
        </p>
      </button>
    </div>
    <div class="col">
      <button mat-raised-button class="btn-primary" color="primary" (click)="mostrarModal('aceptar')">
        <p class="m-0" style="font-weight: 600;">
          Aceptar
        </p>
      </button>
    </div>
  </div>

</div>

<!-- Modal de confirmación de aceptación -->
<div class="modal-container" *ngIf="modalActual === 'aceptar'">
  <h2 class="modal-title">¿Está seguro de que quiere aceptar la consulta?</h2>
  <div class="buttons-box row">
    <div class="col">
      <button mat-button class="btn-secondary" (click)="mostrarModal('solicitud')">
        <p class="m-0" style="font-weight: 600;">
          No
        </p>
      </button>
    </div>
    <div class="col">
      <button mat-raised-button class="btn-primary" color="primary" 
  (click)="confirmarMedico(true)" [disabled]="isLoading">
  <p class="m-0" style="font-weight: 600;">
    Sí
  </p>
</button>

    </div>
  </div>
</div>

<!-- Modal de confirmación de cancelación -->
<div class="modal-container" *ngIf="modalActual === 'cancelar'">
  <h2 class="modal-title">¿Está seguro de que quiere rechazar la consulta?</h2>
  <div class="buttons-box row">
    <div class="col">
      <button mat-button class="btn-secondary" (click)="mostrarModal('solicitud')">
        <p class="m-0" style="font-weight: 600;">
          No
        </p>
      </button>
    </div>
    <div class="col">
      <button mat-raised-button class="btn-primary" color="warn" (click)="confirmarMedico(false)">
        <p class="m-0" style="font-weight: 600;">
          Sí
        </p>
      </button>
    </div>
  </div>
</div>
</ng-container>

<ng-container *ngIf="this.usuario.typ_id == 2">
  
  <!-- Modal de solicitud -->
  <div class="modal-container" *ngIf="modalActual === 'solicitud'">
    <h2 class="modal-title">¡Se te ha asignado un médico!</h2>

    <div class="modal-avatar">
      <span class="avatar-initials">
        {{ data.consulta.nombre_doctor?.charAt(0) || '?' }}
        {{ data.consulta.apellido_doctor?.charAt(0) || '?' }}
      </span>
    </div>

    <h3 class="modal-name">
      {{ data.consulta.nombre_doctor }} {{ data.consulta.apellido_doctor }}
    </h3>

    <p class="modal-reason">
      <strong>Especialidad:</strong> {{ data.consulta.spe_name }}
    </p>

    <div class="buttons-box row">
      <!-- <div class="col">
        <button mat-button class="btn-secondary" (click)="mostrarModal('cancelar')">
          <p class="m-0" style="font-weight: 600;">
            Rechazar
          </p>
        </button>
      </div> -->
      <div class="col">
        <button mat-raised-button class="btn-primary" color="primary"(click)="confirmarPaciente(true)">
          <p class="m-0" style="font-weight: 600;">
            Aceptar
          </p>
        </button>
      </div>
    </div>
  </div>

  <!-- Modal de confirmación de aceptación -->
  <div class="modal-container" *ngIf="modalActual === 'aceptar'">
    <h2 class="modal-title">¿Estás seguro de que quieres aceptar la consulta?</h2>
    <div class="buttons-box row">
      <div class="col">
        <button mat-button class="btn-secondary" (click)="mostrarModal('solicitud')">
          <p class="m-0" style="font-weight: 600;">
            No
          </p>
        </button>
      </div>
      <div class="col">
        <button mat-raised-button class="btn-primary" color="primary" (click)="confirmarPaciente(true)">
          <p class="m-0" style="font-weight: 600;">
            Sí
          </p>
        </button>
      </div>
    </div>
  </div>

  <!-- Modal de confirmación de cancelación -->
  <div class="modal-container" *ngIf="modalActual === 'cancelar'">
    <h2 class="modal-title">¿Estás seguro de que quieres rechazar la consulta?</h2>
    <div class="buttons-box row">
      <div class="col">
        <button mat-button class="btn-secondary" (click)="mostrarModal('solicitud')">
          <p class="m-0" style="font-weight: 600;">
            No
          </p>
        </button>
      </div>
      <div class="col">
        <button mat-raised-button class="btn-primary" color="warn" (click)="confirmarPaciente(false)">
          <p class="m-0" style="font-weight: 600;">
            Sí
          </p>
        </button>
      </div>
    </div>
  </div>

</ng-container>



